export class DecodedToken {
	exp: number;
	iat: number;
	role: string;
	sub: string;
	userId: string;
	username: string;
	tenantId: string;
	supplierId: string;
}
